export default "__VITE_ASSET__AIUbCkaI__"